<template>
  <div class="footer d-flex align-items-center justify-content-center text-muted fix-pointer">
    <p class="m-2">
      {{ $t('generic.developedBy') }}
      <a
        @click="$emit('link')"
        href="https://solucx.com.br/smart-survey?utm_source=pesquisa&utm_medium=disparo&utm_campaign=by_solucx"
        target="_blank"
        class="text-solucx"
        ><img class="mb-1" :src="logoUrl" alt="Logo SoluCX"
      /></a>
    </p>
  </div>
</template>
<style>
.app__tt .footer {
  font-size: 6px;
}
</style>

<script>
export default {
  name: 'SoluCXFooter',
  data() {
    return {
      logoUrl: `${process.env.VUE_APP_STATICS_URL}/img/logos/solucx-logo-colorido-sem-descritor-100x25.png`,
    };
  },
};
</script>
